module.exports = __webpack_public_path__ + "static/media/400397_02.42b2dff9.png";